module.exports = __webpack_public_path__ + "static/smartpay_21-moto-b8f0b661744245b33765833108d61586.svg";